import { SOURCE_STATUS_STEPS } from "./orderWorkspaceRules";
import styles from "./OrdersWorkspace.module.css";

export default function OrderStatusProgress({ status }) {
  const current = SOURCE_STATUS_STEPS.indexOf(status);

  return (
    <ol className={styles.statusProgress} aria-label="Fulfillment progress">
      {SOURCE_STATUS_STEPS.map((step, index) => {
        const stateClass = index < current ? styles.statusStepDone : index === current ? styles.statusStepCurrent : "";

        return (
          <li key={step} className={`${styles.statusStep} ${stateClass}`}>
            <span aria-hidden="true">{index < current ? "✓" : index + 1}</span>
            <small>{step}</small>
          </li>
        );
      })}
    </ol>
  );
}
